import { AxiosRequestConfig, AxiosResponse } from "axios";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import AxiosActions from "../../AxiosActions";

export const getWorkflowGroupsForTenant = (config: AxiosRequestConfig, spinner = true) => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/workflow-template-group/list`, config, spinner);
};

export const getPublishedWorkflowTemplates = (config: any, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `health/workflow-template-group/published/list`, config, spinner);
};

export const createWorkflowTemplateGroup = (
    dto: { category: string; name: string; type: string },
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, "/health/workflow-template-group", dto, config, spinner);
};

export const createWorkflowTemplateGroupErrorsThrow = (
    dto: { category: string; name: string; type: string },
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.postErrorsAreThrown(getAxiosInstances().V2, "/health/workflow-template-group", dto, config, spinner);
};

export const updateWorkflowTemplateGroup = (
    templateId: number | string,
    dto: { category?: string; name?: string },
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `health/workflow-template-group/${templateId}`, dto, config, spinner);
};

export const cloneWorkflowTemplate = (
    groupTemplateId: number | string,
    templateId: number | string,
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `/health/workflow-template-group/${groupTemplateId}/template/${templateId}/clone`, {}, config, spinner);
};

export const getTestProductsByWorkflowTemplateGroupRelation = (
    workflowTemplateId: number | string,
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/workflow-template-group/${workflowTemplateId}/test-product/list`, config, spinner);
};

export const assignUnassignTestProductsToWorkflowTemplateGroup = (
    workflowTemplateId: number | string,
    dto: { idsToAdd?: number[]; idsToRemove?: number[] },
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `/health/workflow-template-group/${workflowTemplateId}/manage-test-product`, dto, config, spinner);
};

export const getWorkflowTemplateGroupById = (id: number | string, config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/workflow-template-group/${id}`, config, spinner);
};

export const cloneWorkflowTemplateGroup = (workflowTemplateId: number, showSpinner = true): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `health/workflow-template-group/${workflowTemplateId}/clone`, null, {}, showSpinner);
};

export const deleteWorkflowTemplateGroup = (workflowTemplateId: number, showSpinner = true): Promise<AxiosResponse> => {
    return AxiosActions.delete(getAxiosInstances().V2, `health/workflow-template-group/${workflowTemplateId}`, {}, showSpinner);
};

export const getWorkflowTemplateById = (id: number | string, config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/workflow-template/${id}`, config, spinner);
};

export const getPublishedWorkflowTemplateById = (
    groupId: number | string,
    id: number | string,
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/workflow-template-group/${groupId}/workflow-template/${id}`, config, spinner);
};

export const updateWorkflowTemplate = (id: number | string, dto, config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `/health/workflow-template/${id}`, dto, config, spinner);
};

export const getWorkFlowStepConfiguration = (templateId: number, stepId: number, config: AxiosRequestConfig, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/workflow-template/${templateId}/step/${stepId}/configuration`, config, spinner);
};

export const updateWorkFlowStepConfiguration = <T>(stepId: number, dto: T, config: AxiosRequestConfig, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.put(
        getAxiosInstances().V2,
        `/health/workflow-template-step/${stepId}/configuration`,
        dto,
        { ...config, withCredentials: true },
        spinner,
    );
};

export const resetWorkflowStepConfiguration = (
    id: number | string,
    type: string,
    dto,
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.put(
        getAxiosInstances().V2,
        `/health/workflow-template-step/${id}/configuration/${type}/reset`,
        dto,
        { ...config, withCredentials: true },
        spinner,
    );
};

export const getDecisionWorkflowSteps = (config: AxiosRequestConfig, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, "/health/workflow-template-step-decision/list", config, spinner);
};

export const createStickyNote = (templateId: number, dto: any, config: AxiosRequestConfig, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/health/workflow-template/${templateId}/sticky-note`, dto, config, spinner);
};

export const updateStickyNote = (templateId: number, noteId: number, dto: any, config: AxiosRequestConfig, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `/health/workflow-template/${templateId}/sticky-note/${noteId}`, dto, config, spinner);
};

export const deleteStickyNote = (templateId: number, noteId: number, config: AxiosRequestConfig, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.delete(getAxiosInstances().V2, `/health/workflow-template/${templateId}/sticky-note/${noteId}`, config, spinner);
};

export const createCustomStepDecision = (dto: any, config?: any): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `health/workflow-template-step-decision`, dto, { ...config, withCredentials: true }, true);
};

export const getCustomStepDecisionById = (id: number, config?: any): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/workflow-template-step-decision/${id}`, config, true);
};

export const deleteCustomStepDecisionById = (id: number, config?: any, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.delete(getAxiosInstances().V2, `/health/workflow-template-step-decision/${id}`, config, spinner);
};

export const updateCustomStepDecisionById = (id: number, dto?: any, config?: any): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `/health/workflow-template-step-decision/${id}`, dto, config, true);
};

export const updateCustomNodeStepDecisionById = (nodeId, decisionId, dto, config = {}, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `/health/workflow-template-step/${nodeId}/decision/${decisionId}`, dto, config, spinner);
};

export const getWorkflowTemplateGroups = (dto, config: AxiosRequestConfig, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V3, `/health/grid/workflow-template-group`, dto, config, spinner);
};

export const getWorkflowTemplateApiJson = (config: AxiosRequestConfig, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/workflow-step-configuration/webhook/body-model`, config, spinner);
};

export const exportWorkflowTemplateGroup = (id: number | string, config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/workflow-template-group/${id}/export`, { ...config, responseType: "blob" }, spinner);
};

export const importWorkflowTemplateGroup = (formData: FormData, config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/health/workflow-template-group/import`, formData, config, spinner);
};

export const getWorkflowJourneyTemplateApiJson = (config: AxiosRequestConfig, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/journey/body-model`, config, spinner);
};
